export default "__VITE_ASSET__CiZtVjqb__"